import "core-js/modules/es.object.assign.js";

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from 'react';
import Svg, { Path } from 'react-native-svg';

function CheckmarkCircle(props) {
  return React.createElement(Svg, _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24"
  }, props), React.createElement(Path, {
    fillRule: "evenodd",
    d: "M4.457 14.665A8 8 0 019.335 4.457c.58-.205 1.593-.436 2.741-.442 1.148-.006 2.362.214 3.41.843a1 1 0 101.029-1.715c-1.454-.872-3.06-1.135-4.448-1.128-1.387.007-2.622.282-3.398.556-5.207 1.84-7.938 7.552-6.098 12.76 1.84 5.207 7.552 7.938 12.76 6.098 5.207-1.84 7.938-7.552 6.098-12.76a10.07 10.07 0 00-.56-1.29l1.804-1.64a1 1 0 00-1.346-1.479L11.033 13.62l-2.326-2.326a1 1 0 00-1.414 1.414l3 3a1 1 0 001.38.033l7.652-6.957a8 8 0 11-14.868 5.882z",
    clipRule: "evenodd"
  }));
}

export default CheckmarkCircle;